<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- Small loader for content -->
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loading) {
<div>
    <!-- JSON View Section -->
    <div style="width: 100%; margin-bottom: 20px;">
      <pre class="old_new_view json_view">{{jsonView}}</pre>
    </div>

    <!-- Table Section -->
    <div style="width: 100%; margin-bottom: 20px;">
      @if (sltApiResponseData.length > 0) {
<div class="table-responsive" style="height: 400px;">
        <table class="table table-hover table-bordered table-striped table-condensed custom-table">
          <thead>
            <tr>
              <th>LEID</th>
              <th>LE NAME</th>
              <th>EIN</th>
              <th>HO LEID</th>
              <th>STATE DOMICILE</th>
              <th>HO CDR NO</th>
              <th>HO REPORTING PERIOD</th>
              <th>ME CODE</th>
              <th>ADDRESS LINE 1</th>
              <th>ADDRESS LINE 2</th>
              <th>CDR NO</th>
              <th>REPORTING PERIOD</th>
              <th>CONSOLE ENTITY</th>
              <th>ENTITY TYPE</th>
            </tr>
          </thead>
          <tbody>
            @for (obj of sltApiResponseData; track $index) {
<tr>
              <td>{{obj.leid}}</td>
              <td>{{obj.le_name}}</td>
              <td>{{obj.ein}}</td>
              <td>{{obj.ho_leid}}</td>
              <td>{{obj.state_domicile}}</td>
              <td>{{obj.ho_cdr_no}}</td>
              <td>{{obj.ho_reporting_period}}</td>
              <td [ngClass]="{'warning': obj.isPresent === false}">{{obj.me_code}}</td>
              <td>{{obj.address_line1}}</td>
              <td>{{obj.address_line2}}</td>
              <td>{{obj.cdr_no}}</td>
              <td>{{obj.reporting_period}}</td>
              <td>{{obj.consol_entity}}</td>
              <td>{{obj.entity_type}}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
  </div>
}
</div>

<!-- STANDARD Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
